const profilesCdn = 'https://receiptsai-marketing.sfo3.cdn.digitaloceanspaces.com/profiles'

export interface Testimonial {
  name: string;
  image: string | null;
  title: string;
  body: string;
}

export const testimonials: Testimonial[] = [
  {
    name: 'Kirsten H.',
    image: `${profilesCdn}/profile2.png`,
    title: "The easiest tool I've ever used.",
    body: 'As soon as you get a receipt you can scan it, the AI captures the relevant information, and there is very little interaction to get to the final expense submission.',
  },
  {
    name: 'Luis G.',
    image: `${profilesCdn}/profile1.png`,
    title: 'Great Service!',
    body: "Ronald and the team were super responsive to my questions and feature requests. I've never had an experience like this before from a software developer.",
  },
  {
    name: 'Vannesa T.',
    image: `${profilesCdn}/profile4.jpg`,
    title: 'Simple, Straight-forward',
    body: 'After business trips, the last thing anyone wants is sorting receipts. ReceiptsAI makes my process much easier.',
  },
  {
    name: 'Norma W.',
    image: `${profilesCdn}/normaw.png`,
    title: 'Very easy to use',
    body: 'As someone who needs to keep track of monthly expenses, it saves me so much time. I love how it categorizes everything automatically.',
  },
  {
    name: 'Alice K.',
    image: `${profilesCdn}/profile5.jpg`,
    title: 'Impressive!',
    body: 'I run multiple businesses and keeping track of receipts was a nightmare. ReceiptsAI transformed how I handle expense tracking.',
  },
  {
    name: 'Josh D.',
    image: null,
    title: 'Effortless',
    body: 'It is effortless and saves me hours every month.',
  },
]
